import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import store from './store/index';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import CanvasPlugin from 'configurator-base-app';
import Cookies from 'vue-cookies';
import vuetify from './plugins/vuetify';
import VueWaypoint from 'vue-waypoint';
import router from './router';
// import './stylus/main.styl'
import 'animate.css/animate.min.css';
import "./theme/custom.less";
import './assets/configurator.less';
import config, { setCustomConfig } from "./config/custom-config";
Vue.use(VueI18n);
Vue.use(VueWaypoint);
Vue.use(Cookies);
const i18n = new VueI18n({
  locale: 'IT',
  //messages,
  fallbackLocale: 'EN'
});
// Configurazione configurator-base-app
Vue.prototype.$iperStoresMode = process.env.VUE_APP_IPER_STORES_MODE;
Vue.config.productionTip = false;
Vue.filter('capitalize', str => {
  const strLower = str.toLowerCase();
  return strLower.charAt(0).toUpperCase() + strLower.slice(1);
});
Vue.filter('upperCase', s => {
  if (typeof s !== 'string') return '';
  return s.toUpperCase();
});
Vue.filter('decodeLensModel', l => {
  if (typeof l !== 'string') {
    return '';
  } else {
    if (l == 'MF1.50SF-UC') {
      return 'MONOFOCALE 1.50 SFERICA-UC';
    } else if (l == 'MF1.56SF-HMC') {
      return 'MONOFOCALE 1.56 SFERICA-HMC';
    } else if (l == 'MF1.56SF-HMC BLUCUT') {
      return 'MONOFOCALE 1.56 SFERICA-HMC BLUCUT';
    } else if (l == 'MF1.60AS-SHMC') {
      return 'MONOFOCALE 1.60 ASFERICA-SHMC';
    } else if (l == 'MF1.67AS-SHMC') {
      return 'MONOFOCALE 1.67 ASFERICA-SHMC';
    }
  }
});
function parsePossibleJson(value) {
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
function extractConfigPayload(payload) {
  var _payload$data;
  if (!payload) return null;
  const base = (_payload$data = payload === null || payload === void 0 ? void 0 : payload.data) !== null && _payload$data !== void 0 ? _payload$data : payload;
  // Common API shape: { success, data: { id, nome, json } }
  if (base && typeof base === "object" && "json" in base) {
    return parsePossibleJson(base.json);
  }
  // Fallback for arrays: [{..., json: "..."}]
  if (Array.isArray(base) && base.length > 0) {
    const first = base[0];
    if (first && typeof first === "object" && "json" in first) {
      return parsePossibleJson(first.json);
    }
  }
  // If API already returns config object directly
  if (base && typeof base === "object") {
    return base;
  }
  return null;
}
async function loadRuntimeConfigByName() {
  const configName = `${process.env.VUE_APP_CUSTOM_CONFIG_NAME || ""}`.trim();
  if (!configName) return null;
  try {
    var _payload$data2;
    const defaultEndpointPath = "/v3/admin/custom/configurators/get-custom-configurator";
    const endpointRaw = `${process.env.VUE_APP_CUSTOM_CONFIG_ENDPOINT || defaultEndpointPath}`.trim();
    const baseUrl = `${process.env.VUE_APP_REST_URL || window.location.origin || ""}`.trim();
    let endpoint = endpointRaw;
    if (!endpointRaw.startsWith("http")) {
      endpoint = `${baseUrl.replace(/\/+$/, "")}/${endpointRaw.replace(/^\/+/, "")}`;
    } else {
      // If only host is provided (e.g. http://10.40.2.9:8081), append default API path.
      try {
        const parsedEndpoint = new URL(endpointRaw);
        const path = parsedEndpoint.pathname || "";
        if (path === "/" || path === "") {
          endpoint = `${endpointRaw.replace(/\/+$/, "")}${defaultEndpointPath}`;
        }
      } catch {
        // fallback to raw endpoint
      }
    }
    const url = new URL(endpoint);
    url.searchParams.set('nome', configName);
    const response = await fetch(url.toString(), {
      cache: 'no-store'
    });
    if (!response.ok) return null;
    const payload = await response.json();
    const base = (_payload$data2 = payload === null || payload === void 0 ? void 0 : payload.data) !== null && _payload$data2 !== void 0 ? _payload$data2 : payload;
    let normalized = null;
    if (Array.isArray(base)) {
      var _selected$json;
      const byName = base.find(row => `${(row === null || row === void 0 ? void 0 : row.nome) || ""}`.trim() === configName);
      const selected = byName || base[0] || null;
      normalized = parsePossibleJson((_selected$json = selected === null || selected === void 0 ? void 0 : selected.json) !== null && _selected$json !== void 0 ? _selected$json : selected);
    } else {
      normalized = parsePossibleJson(extractConfigPayload(payload));
    }
    if (normalized && typeof normalized === 'object') {
      return normalized;
    }
    return null;
  } catch {
    return null;
  }
}
function buildSettingsFromConfig() {
  const runtimeSettings = config.settings || {};
  const envExclusive = `${process.env.VUE_APP_CONFIG_ESCLUSIVA || ""}`.trim();
  const exclusiveCheck = config.esclusivaCheck === true || `${config.esclusivaCheck || ""}`.toLowerCase() === "si" || `${config.esclusivaCheck || ""}`.toLowerCase() === "sì";
  const configExclusive = exclusiveCheck ? `${config.esclusiva || ""}`.trim() : "";
  return {
    VUE_APP_REST_URL: `${runtimeSettings.VUE_APP_REST_URL || process.env.VUE_APP_REST_URL || ""}`,
    VUE_APP_CONFIG_IDENTIFIER: `${config.site_id || runtimeSettings.VUE_APP_CONFIG_IDENTIFIER || process.env.VUE_APP_CONFIG_IDENTIFIER || ""}`,
    VUE_APP_CONFIG_ESCLUSIVA: envExclusive || configExclusive,
    VUE_APP_COLORS_URL: `${runtimeSettings.VUE_APP_COLORS_URL || process.env.VUE_APP_COLORS_URL || ""}`,
    VUE_APP_MODEL_URL: `${runtimeSettings.VUE_APP_MODEL_URL || process.env.VUE_APP_MODEL_URL || ""}`,
    VUE_APP_CONFIG_DATABASE: `${config.config_database || runtimeSettings.VUE_APP_CONFIG_DATABASE || process.env.VUE_APP_CONFIG_DATABASE || ""}`,
    VUE_APP_SENDGRID_SHARE_MAIL_TEMPLATE_ID: runtimeSettings.VUE_APP_SENDGRID_SHARE_MAIL_TEMPLATE_ID || process.env.VUE_APP_SENDGRID_SHARE_MAIL_TEMPLATE_ID,
    VUE_APP_HANDLE_SUBLINE_TEMPLES: `${runtimeSettings.VUE_APP_HANDLE_SUBLINE_TEMPLES || process.env.VUE_APP_HANDLE_SUBLINE_TEMPLES || ""}`,
    VUE_APP_MULTILINETEMPLES: `${runtimeSettings.VUE_APP_MULTILINETEMPLES || process.env.VUE_APP_MULTILINETEMPLES || ""}`
  };
}
function logConfiguratorSettings(label, settings) {
  console.log(`[template-base] ${label}`, {
    VUE_APP_REST_URL: settings.VUE_APP_REST_URL,
    VUE_APP_CONFIG_IDENTIFIER: settings.VUE_APP_CONFIG_IDENTIFIER,
    VUE_APP_COLORS_URL: settings.VUE_APP_COLORS_URL,
    VUE_APP_MODEL_URL: settings.VUE_APP_MODEL_URL,
    VUE_APP_CONFIG_DATABASE: settings.VUE_APP_CONFIG_DATABASE,
    VUE_APP_CONFIG_ESCLUSIVA: settings.VUE_APP_CONFIG_ESCLUSIVA,
    VUE_APP_SENDGRID_SHARE_MAIL_TEMPLATE_ID: settings.VUE_APP_SENDGRID_SHARE_MAIL_TEMPLATE_ID,
    VUE_APP_HANDLE_SUBLINE_TEMPLES: settings.VUE_APP_HANDLE_SUBLINE_TEMPLES,
    VUE_APP_MULTILINETEMPLES: settings.VUE_APP_MULTILINETEMPLES
  });
}
async function bootstrap() {
  const runtimeConfig = await loadRuntimeConfigByName();
  if (!runtimeConfig) {
    console.error("[template-base] Configurazione DB non trovata. Imposta VUE_APP_CUSTOM_CONFIG_NAME e verifica endpoint/API.");
    return;
  }
  console.info("[template-base] Config caricata dal DB tramite nome:", process.env.VUE_APP_CUSTOM_CONFIG_NAME);
  if (runtimeConfig && typeof runtimeConfig === 'object') {
    const runtimeSettings = runtimeConfig.settings || {};
    const normalizedConfig = {
      ...runtimeConfig,
      config_database: runtimeConfig.config_database || runtimeSettings.VUE_APP_CONFIG_DATABASE || "",
      site_id: runtimeConfig.site_id || runtimeSettings.VUE_APP_CONFIG_IDENTIFIER || ""
    };
    setCustomConfig(normalizedConfig);
  }
  const settings = buildSettingsFromConfig();
  logConfiguratorSettings("Settings passati a configurator-base-app", settings);
  // @ts-ignore
  Vue.use(CanvasPlugin, {
    store,
    settings
  });
  const runtimeLine = `${settings.VUE_APP_CONFIG_IDENTIFIER || ""}`.trim();
  if (runtimeLine) {
    store.commit("configurator/setOverrideLinea", runtimeLine);
    axios.defaults.headers.common["line-id"] = runtimeLine;
    axios.defaults.headers.common["site-id"] = runtimeLine;
  }
  new Vue({
    i18n,
    store,
    vuetify,
    router,
    render: h => h(App),
    created() {
      // @ts-ignore
      Vue.component('Canvas3d', this.$canvas3d);
      // @ts-ignore
      this.$rest.getCountryCode().then(response => {
        i18n.locale = response.data;
      });
      // @ts-ignore
      this.$rest.getTranslations().then(translations => {
        const messages = translations.data;
        for (const key in messages) {
          const allLocaleMessages = messages[key]["message"];
          const availableLocaleMessages = [];
          // Check which messages are already translated
          // Don't consider all the other ones
          for (const [msg, translated] of Object.entries(allLocaleMessages)) {
            if (translated != "") {
              availableLocaleMessages[msg] = translated;
            }
          }
          i18n.setLocaleMessage(key, {
            message: availableLocaleMessages
          });
        }
      });
    }
  }).$mount('#app');
}
bootstrap();